import { dateColumn } from "..";

const lastUpdatedAtColumn = (Header = "Last Updated On") => dateColumn("updatedAt", Header);

export default lastUpdatedAtColumn;
